import { createFileRoute } from '@tanstack/react-router';
import { LayoutDetailRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/')({
  component: LayoutDetailRoute,
});
